import { render, staticRenderFns } from "./image-tab.vue?vue&type=template&id=88b7ae6c&scoped=true"
import script from "./image-tab.vue?vue&type=script&lang=js"
export * from "./image-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b7ae6c",
  null
  
)

export default component.exports